import { CheckCircle } from 'lucide-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { setCurrentStep } from '../../redux/Slices/InterviewSlice';
import { Language } from '../../redux/Slices/InterviewSlice/types';
import { setCurrentTab } from '../../redux/Slices/ResultsSlice/ResultsSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store/hooks';
import { useHrEndTestMutation } from '../../services/hrApi';

const InterviewComplete = ({
  setCurrentQuestionIndex,
  setSelectedLanguage,
  setShowTimer,
  setIsRecording,
  setIsPlayingAudio,
  setOverallTimer
}: {
  setCurrentQuestionIndex: (index: number) => void;
  setSelectedLanguage: (language: Language | null) => void;
  setShowTimer: (showTimer: boolean) => void;
  setIsRecording: (isRecording: boolean) => void;
  setIsPlayingAudio: (isPlayingAudio: boolean) => void;
  setOverallTimer: (overallTimer: number) => void;
}) => {
  const dispatch = useAppDispatch();
  const [hrEndTest] = useHrEndTestMutation();
  const { testData } = useAppSelector(state => state.root.interview);

  const navigate = useNavigate();

  const handleNavigate = (route: string) => {
    dispatch(setCurrentStep('start'));
    setCurrentQuestionIndex(0);
    setSelectedLanguage(null);
    setShowTimer(false);
    setIsRecording(false);
    setIsPlayingAudio(false);
    setOverallTimer(720);
    route && navigate('/results');
    dispatch(setCurrentTab('HR'));
  };

  const handleEndTest = async () => {
    setSelectedLanguage(null);
    setShowTimer(false);
    setIsRecording(false);
    setIsPlayingAudio(false);
    setOverallTimer(1800);
    try {
      await hrEndTest(testData?.id);
    } catch (err) {
      console.log(err, 'err');
    }
  };

  useEffect(() => {
    if (testData?.id) {
      handleEndTest();
    }
  }, [testData]);

  return (
    <div className='w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl'>
      <div className='mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-green-500 to-blue-600'>
        <CheckCircle className='h-8 w-8 text-white' />
      </div>
      <h1 className='mb-4 text-3xl font-bold text-gray-800'>
        HR Interview Complete!
      </h1>
      <p className='mb-8 text-gray-600'>
        Thank you for completing the HR interview. Your responses have been
        recorded successfully.
      </p>
      <button
        onClick={() => handleNavigate('')}
        className='w-full rounded-xl bg-gradient-to-r from-green-500 to-blue-600 px-6 py-3 font-semibold text-white shadow-lg transition-all duration-200 hover:from-green-600 hover:to-blue-700'
      >
        Start New HR Interview
      </button>
      <button
        onClick={() => handleNavigate('navigate')}
        className='mt-3 w-full rounded-xl bg-gradient-to-r from-green-500 to-blue-600 px-6 py-3 font-semibold text-white shadow-lg transition-all duration-200 hover:from-green-600 hover:to-blue-700'
      >
        View Results.
      </button>
    </div>
  );
};

export default InterviewComplete;
